import React, { useEffect, useState } from 'react'
import {
  CAvatar,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CFormSwitch,
  CImage,
  CInputGroup,
  CInputGroupText,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import {
  cibGmail,
  cilList,
  cilLockLocked,
  cilLockUnlocked,
  cilMenu,
  cilMobile,
  cilPeople,
  cilTrash,
  cilUser,
} from '@coreui/icons'
import imgPic from 'src/assets/images/profile.png'
import { useDispatch, useSelector } from 'react-redux'
import { getAdminUsers, updateAdminMenus } from 'src/redux/adminusers'
import { deleteAdminUser, signupUser, updateAdminUser } from 'src/redux/signup'
import { toast } from 'react-toastify'
import Multiselect from 'multiselect-react-dropdown'
import swal from 'sweetalert'

const Adminusers = () => {
  const [loading, setLoading] = useState(false)
  const [image, setImage] = useState(null)
  const handleImageChange = (e) => {
    const file = e.target.files[0]
    setImage(URL.createObjectURL(file))
    setFormData({ ...formData, profile: file })
  }

  const [formData, setFormData] = useState({
    name: '',
    email_id: '',
    mobile_no: '',
    password: '',
    confirmPassword: '',
    profile: '',
    menus: [],
  })

  const dispatch = useDispatch()

  const { adminUsers } = useSelector((state) => state.adminusers)
  const { isSignedUp } = useSelector((state) => state.signup)
  const { navigationData } = useSelector((state) => state.adminnavigation)

  // Function to extract id and name from nested navigation data
  const extractIdAndName = (data) => {
    const result = []

    data?.forEach((item) => {
      if (item.type === 'item') {
        result.push({ id: item.id, name: item.name })
      } else if (item.type === 'group' && Array.isArray(item.items)) {
        result.push({ id: item.id, name: item.name })
        item?.items?.forEach((subItem) => {
          result.push({ id: subItem.id, name: subItem.name })
        })
      }
    })

    return result
  }

  const flattenedData = extractIdAndName(navigationData)

  useEffect(() => {
    dispatch(getAdminUsers())
    if (isSignedUp) {
      setFormData({
        name: '',
        email_id: '',
        mobile_no: '',
        password: '',
        confirmPassword: '',
        profile: '',
      })
      setImage(null)
    }
  }, [dispatch, isSignedUp, loading])

  const handleRegister = async () => {
    if (!formData.profile) {
      toast('Picture required!', { type: 'info' })
    } else if (!formData.name) {
      toast('Name required!', { type: 'info' })
    } else if (!formData.email_id) {
      toast('Email required!', { type: 'info' })
    } else if (!formData.mobile_no) {
      toast('Mobile required!', { type: 'info' })
    } else if (!formData.password) {
      toast('Password required!', { type: 'info' })
    } else if (formData.password !== formData.confirmPassword) {
      toast('Password Not Match!', { type: 'info' })
    } else {
      const credentials = {
        name: formData.name,
        email_id: formData.email_id,
        mobile_no: formData.mobile_no,
        password: formData.password,
        profile: formData.profile,
        menus: JSON.stringify(formData.menus),
      }
      const formDataToSend = new FormData()
      Object.keys(credentials).forEach((key) => {
        formDataToSend.append(key, credentials[key])
      })
      try {
        dispatch(signupUser(formDataToSend))
      } catch (error) {
        toast(error.message, { type: 'error' })
      }
    }
  }

  async function handleDelete(id) {
    setLoading(true)
    await dispatch(deleteAdminUser(id))
    setLoading(false)
  }

  const [visible, setVisible] = useState(false)
  const [selectedMenus, setSelectedMenus] = useState([])
  const [selectedId, setSelectedId] = useState(null)

  const handleUpdateAdminMenus = async () => {
    const selectedMenuIds = selectedMenus.map((item) => item.id)
    const body = {
      adminId: selectedId,
      menuIds: JSON.stringify(selectedMenuIds),
    }
    await dispatch(updateAdminMenus(body))
    setVisible(false)
  }

  const handleStatusToggle = async (user) => {
    const updatedStatus = user.status === 'Pending' ? 'Active' : 'Pending'
    const body = {
      status: updatedStatus,
    }

    await dispatch(updateAdminUser(user.user_code, body))
  }

  const [passwordVisibility, setPasswordVisibility] = useState({})

  const hideSensitiveInfo = (info) => {
    if (!info) return ''
    return '*'.repeat(info.length)
  }

  const togglePasswordVisibility = (userCode) => {
    setPasswordVisibility((prev) => ({
      ...prev,
      [userCode]: !prev[userCode],
    }))
  }

  return (
    <div className="bg-light d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={9} lg={7} xl={8}>
            <CTable align="middle" className="mb-0 border" hover responsive>
              <CTableHead color="light">
                <CTableRow>
                  <CTableHeaderCell></CTableHeaderCell>
                  <CTableHeaderCell className="text-center">
                    <CIcon icon={cilPeople} />
                  </CTableHeaderCell>
                  <CTableHeaderCell>Username</CTableHeaderCell>
                  <CTableHeaderCell>Email Address</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Mobile</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Password</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Status</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Action</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {adminUsers?.admin_user?.map((item, index) => (
                  <CTableRow v-for="item in tableItems" key={index}>
                    <CTableDataCell>{index + 1})</CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div className="image-size">
                        <CAvatar size="md" src={item.profile} className="image-profile" />
                      </div>
                    </CTableDataCell>
                    <CTableDataCell>
                      <div>{item.name}</div>
                      <div className="small text-medium-emphasis">
                        <strong>{item.username} </strong> | {item.user_type}
                      </div>
                    </CTableDataCell>

                    <CTableDataCell>
                      <div className="clearfix">
                        <small className="text-medium-emphasis">{item.email_id}</small>
                      </div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div className="clearfix">
                        <small className="text-medium-emphasis">{item.mobile_no}</small>
                      </div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div className="clearfix d-flex align-items-center justify-content-center">
                        <small className="text-medium-emphasis me-2">
                          {passwordVisibility[item.user_code]
                            ? item?.password
                            : hideSensitiveInfo(String(item?.password))}
                        </small>
                        <CButton
                          color="light"
                          size="sm"
                          onClick={() => togglePasswordVisibility(item.user_code)}
                        >
                          <CIcon
                            icon={
                              passwordVisibility[item.user_code] ? cilLockUnlocked : cilLockLocked
                            }
                          />
                        </CButton>
                      </div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CFormSwitch
                        disabled={item.username === '1001'}
                        color="success"
                        size="sm"
                        checked={item.status === 'Active'}
                        onChange={() => handleStatusToggle(item)}
                      />
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CButtonGroup role="group">
                        <CButton
                          disabled={item.username === '1001'}
                          color="danger"
                          size="sm"
                          onClick={() =>
                            swal({
                              title: 'Are you sure? ',
                              text: 'You want to delete this admin user!',
                              icon: 'warning',
                              buttons: ['No', 'Yes'],
                              dangerMode: true,
                            }).then((willDelete) => {
                              if (willDelete) {
                                handleDelete(item.user_code)
                              } else {
                                console.log(willDelete)
                              }
                            })
                          }
                        >
                          <CIcon icon={cilTrash} className="text-white" />
                        </CButton>
                        <CButton
                          color="success"
                          size="sm"
                          onClick={() => {
                            setSelectedMenus(item.menus)
                            setSelectedId(item.id)
                            setVisible(true)
                          }}
                        >
                          <CIcon icon={cilMenu} className="text-white" />
                        </CButton>
                      </CButtonGroup>
                    </CTableDataCell>
                  </CTableRow>
                ))}
              </CTableBody>
            </CTable>
          </CCol>
          <CCol md={9} lg={7} xl={4}>
            <CCard className="mx-4">
              <CCardBody className="p-4">
                <CForm>
                  <h1>Admin users</h1>
                  <p className="text-medium-emphasis">Create user account</p>
                  <CImage
                    src={image ? image : imgPic}
                    style={{
                      width: 100,
                      height: 100,
                      borderRadius: 100,
                      justifyContent: 'center',
                    }}
                  />
                  <div className="my-3">
                    <CFormInput type="file" size="sm" id="pickImage" onChange={handleImageChange} />
                  </div>
                  <CInputGroup className="mb-3">
                    <CInputGroupText>
                      <CIcon icon={cilUser} />
                    </CInputGroupText>
                    <CFormInput
                      placeholder="Name"
                      autoComplete="name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    />
                  </CInputGroup>
                  <CInputGroup className="mb-3">
                    <CInputGroupText>
                      <CIcon icon={cibGmail} />
                    </CInputGroupText>
                    <CFormInput
                      placeholder="Email"
                      autoComplete="email"
                      value={formData.email_id}
                      onChange={(e) => setFormData({ ...formData, email_id: e.target.value })}
                    />
                  </CInputGroup>
                  <CInputGroup className="mb-3">
                    <CInputGroupText>
                      <CIcon icon={cilMobile} />
                    </CInputGroupText>
                    <CFormInput
                      placeholder="Mobile"
                      autoComplete="mobile"
                      value={formData.mobile_no}
                      onChange={(e) => setFormData({ ...formData, mobile_no: e.target.value })}
                    />
                  </CInputGroup>
                  <CInputGroup className="mb-3">
                    <CInputGroupText>
                      <CIcon icon={cilList} />
                    </CInputGroupText>
                    <Multiselect
                      onKeyPressFn={() => {}}
                      onRemove={(selectedList) => {
                        setFormData((prev) => ({
                          ...prev,
                          menus: selectedList.map((item) => item.id),
                        }))
                      }}
                      onSelect={(selectedList) => {
                        setFormData((prev) => ({
                          ...prev,
                          menus: selectedList.map((item) => item.id),
                        }))
                      }}
                      onSearch={() => {}}
                      options={flattenedData}
                      displayValue="name"
                      className="w-100"
                      placeholder="Select navigation menus"
                    />
                  </CInputGroup>
                  <CInputGroup className="mb-3">
                    <CInputGroupText>
                      <CIcon icon={cilLockLocked} />
                    </CInputGroupText>
                    <CFormInput
                      type="password"
                      placeholder="Password"
                      autoComplete="new-password"
                      value={formData.password}
                      onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    />
                  </CInputGroup>
                  <CInputGroup className="mb-4">
                    <CInputGroupText>
                      <CIcon icon={cilLockLocked} />
                    </CInputGroupText>
                    <CFormInput
                      type="password"
                      placeholder="Repeat password"
                      autoComplete="new-password"
                      value={formData.confirmPassword}
                      onChange={(e) =>
                        setFormData({ ...formData, confirmPassword: e.target.value })
                      }
                    />
                  </CInputGroup>
                  <div className="d-grid">
                    <CButton color="success" onClick={handleRegister}>
                      Create Account
                    </CButton>
                  </div>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
      <CModal visible={visible} onClose={() => setVisible(false)}>
        <CModalHeader onClose={() => setVisible(false)}>
          <CModalTitle>User Navigation Menus</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Multiselect
            onKeyPressFn={() => {}}
            onRemove={(selectedList) => {
              setSelectedMenus(selectedList)
            }}
            onSelect={(selectedList) => {
              setSelectedMenus(selectedList)
            }}
            onSearch={() => {}}
            options={flattenedData}
            selectedValues={selectedMenus}
            displayValue="name"
            showArrow
            className="w-100"
          />
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
          <CButton color="success" onClick={handleUpdateAdminMenus} className="text-white">
            Update
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default Adminusers
